/**
 * Toggle Customer List
 */

import $ from 'jquery';

export default function pandaToggleCustomerList () {

  $('.toggle-customer').click(function () {
    const $this = $(this);
    const toggleTarget = $('.pandaCustomerList');
    if (toggleTarget.hasClass('folded')) {
      toggleTarget.removeClass('folded');
      toggleTarget.slideDown();
      $this.addClass('is-active');
    } else {
      toggleTarget.addClass('folded');
      toggleTarget.slideUp();
      $this.removeClass('is-active');
    }
  });
}




